import { resolveVehicleForService, VEHICLE_WARNING_MESSAGES } from './serviceVehicleAssignment';

/**
 * Acepta un servicio y deja el vehiculo real vinculado.
 *
 * Orden de operaciones (regla de negocio):
 *  1. Se acepta el servicio (RPC accept_service / accept_service_offer).
 *  2. Se resuelve el vehiculo real (materializando el de respaldo si hace falta).
 *  3. Se asigna el vehicle_id real al servicio.
 *
 * Si el paso 2 o 3 falla, el servicio NO se pierde: se devuelve un aviso
 * accionable para que el conductor actualice su perfil.
 */
export const performServiceAccept = async (
    service,
    vehicle,
    { accept, acceptOffer, assignVehicle, driverUid } = {}
) => {
    const serviceId = service?.id || service?.service_id;
    const acceptFn = service?.offered_price ? acceptOffer : accept;

    if (typeof acceptFn !== 'function') {
        return { ok: false, message: 'No se pudo aceptar el servicio. Intentalo de nuevo.' };
    }

    const result = await acceptFn(serviceId, driverUid);

    if (result && result.success === false) {
        return {
            ok: false,
            message: result.message || result.error || 'El servicio ya no está disponible.'
        };
    }

    const resolution = await resolveVehicleForService(vehicle);
    let vehicleWarning = resolution.warning || null;

    if (resolution.vehicleId && typeof assignVehicle === 'function') {
        try {
            await assignVehicle(serviceId, resolution.vehicleId);
        } catch (error) {
            console.warn('No se pudo asignar el vehiculo al servicio:', error);
            vehicleWarning = VEHICLE_WARNING_MESSAGES.ASSIGN_FAILED;
        }
    }

    return { ok: true, serviceId, vehicleWarning };
};
